import { Block, Modal } from '@aloft/toolkit-sui';

import { AllPairedCostAdjustmentSummaryTypes } from '../types.js';
import { usePairedCostAdjustmentSummaryModalContext } from './usePairedCostAdjustmentSummaryModalContext.js';

export const PairedCostAdjustmentSummaryBreakdownDetailModal = (props: {
  renderModalContent: (adjustmentType: AllPairedCostAdjustmentSummaryTypes) => JSX.Element | null;
}) => {
  const { pairedCostModal, setPairedCostModal } = usePairedCostAdjustmentSummaryModalContext();
  const { renderModalContent } = props;

  if (pairedCostModal === null) return null;

  return (
    <Modal
      isOpen={pairedCostModal !== null}
      onClose={() => setPairedCostModal(null)}
      size="6xl"
      showCloseButton
      closeOnEsc
    >
      <Block overflowX="hidden">{renderModalContent(pairedCostModal)}</Block>
    </Modal>
  );
};
